import React from 'react';
import { Color } from '../../../themes/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import theme from '../../../themes/CBB/theme';

const useStyles = makeStyles(() => ({
  divider: {
    overflow: 'hidden',
    width: 'default',
    height: 1,
  },
}));

export default function DividerHorizontal({
  margin = 1,
  color = Color.GREEN_DEEP,
  opacity = 1,
  className = {},
}) {
  const classes = useStyles();

  return (
    <div
      className={classes.divider + ' ' + className}
      style={{
        marginTop: theme.spacing(margin),
        marginBottom: theme.spacing(margin),
        backgroundColor: theme.palette['brand'][color],
        opacity: opacity,
      }}
    />
  );
}
